import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";
import pragatiMaidanImg from "../../images/pargati maidan.webp";

const EventDetailsSection = () => {
  return (
    <section className="section-padding" style={{ paddingTop: "20px" }}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <SectionTitle
              title="Event Details"
              titleStyle={{ color: "#252686" }}
              paragarap=""
            />
          </div>
        </div>
        <div className="row">
          <div
            className="col-lg-6 col-md-6 col-12"
            style={{ marginBottom: "30px" }}
          >
            <div
              className="services-card event-details-image-card"
              style={{
                background: "#fff",
                borderRadius: "15px",
                padding: 0,
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: "400px",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <img
                  src={pragatiMaidanImg}
                  alt="Talkatora Stadium - Event Venue"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div
              className="services-card event-details-content-card"
              style={{
                background: "#fff",
                borderRadius: "15px",
                padding: "40px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                height: "100%",
              }}
            >
              <div
                className="event-detail-item"
                style={{
                  marginBottom: "30px",
                  paddingBottom: "25px",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "10px",
                      background: "#252686",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <i
                      className="fa fa-calendar"
                      style={{ fontSize: "24px", color: "#fff" }}
                    ></i>
                  </div>
                  <div>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#333",
                        marginBottom: "5px",
                      }}
                    >
                      Date
                    </h3>
                    <p
                      style={{ margin: 0, fontSize: "16px", color: "#525252" }}
                    >
                      11th April 2026 (Saturday)
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="event-detail-item"
                style={{
                  marginBottom: "30px",
                  paddingBottom: "25px",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "10px",
                      background: "#F2BC00",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <i
                      className="fa fa-map-marker"
                      style={{ fontSize: "24px", color: "#fff" }}
                    ></i>
                  </div>
                  <div>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#333",
                        marginBottom: "5px",
                      }}
                    >
                      Venue
                    </h3>
                    <p
                      style={{ margin: 0, fontSize: "16px", color: "#525252" }}
                    >
                      Talkatora Stadium, New Delhi
                    </p>
                  </div>
                </div>
              </div>
              <div className="event-detail-item">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "15px" }}
                >
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "10px",
                      background: "#8956B3",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <i
                      className="fa fa-map"
                      style={{ fontSize: "24px", color: "#fff" }}
                    ></i>
                  </div>
                  <div>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#333",
                        marginBottom: "8px",
                      }}
                    >
                      Google Maps Location
                    </h3>
                    <a
                      href="https://maps.app.goo.gl/rEEgyTMEFbsmHzH47"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#252686",
                        textDecoration: "none",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.textDecoration = "underline";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.textDecoration = "none";
                      }}
                    >
                      View on Google Maps{" "}
                      <i
                        className="fa fa-external-link"
                        style={{ marginLeft: "8px" }}
                      ></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventDetailsSection;
